<template>
<!-- <div class="bg-white rounded-lg p-2 shadow-xl overflow-y-auto"> -->
  <table class="w-full">
    <thead>
      <tr class="border-b-2 border-gray-400">
        <th class="w-10" v-if="showSelect">
          <a
            href="#"
            class="p-4 focus:outline-none"
            @keydown.space="onSelectAll()"
            @click.prevent="onSelectAll()">
            <font-awesome-icon class="text-red-500" :icon="['far', isAllSelected() ? 'check-square' : 'square']" ></font-awesome-icon>
          </a>
        </th>
        <th
          :align="header.align"
          v-for="(header, index) in headers"
          :key="index">
          <button class="flex items-center p-4 uppercase font-bold text-sm text-gray-500 focus:outline-none focus:text-gray-700" @click.prevent="sort(header.value)">
            <div>{{ header.text }}</div>
            <font-awesome-icon class="ml-2" :icon="['far', sortDirection === 'asc' ? 'chevron-up' : 'chevron-down']" v-if="header.value === sortBy"></font-awesome-icon>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        :class="itemClass(item, index1)"
        v-for="(item, index1) in result"
        :key="index1">
        <td class="text-center" v-if="showSelect">
          <a
            href="#"
            class="p-4 focus:outline-none"
            @keydown.space="onSelect(item)"
            @click.prevent="onSelect(item)">
            <font-awesome-icon :icon="['far', selectedIndex(item) === -1 ? 'square' : 'check-square']" class="text-red-500"></font-awesome-icon>
          </a>
        </td>
        <td
          class="p-4 cursor-pointer"
          :align="headers[index2].align"
          :class="{ 'whitespace-no-wrap': headers[index2].nowrap }"
          v-for="(header, index2) in headers"
          :key="index2"
          @click="onClick(item)">
            <component 
              v-if="headers[index2].component"
              :is="headers[index2].component" 
              :value="item[headers[index2].value]"
            />
            <template v-else>
              {{ getValue(item, headers[index2].value) }}
            </template>
        </td>
      </tr>
      <tr v-if="result.length === 0 && search !== ''">
        <td :colspan="headers.length + (showSelect ? 1 : 0)">
          <div class="p-4 text-center">Ditt søk etter <span class="font-bold">{{ search }}</span> ga ingen treff.</div></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'data-table',
  props: {
    value: {
      type: Array,
      required: false
    },
    headers: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    },
    showSelect: {
      type: Boolean,
      default: false
    },
    identifier: {
      type: String,
      default: 'id'
    }
  },
  data () {
    return {
      sortBy: null,
      sortDirection: 'asc',
      selectedItems: []
    }
  },
  computed: {
    result () {
      let items = this.items

      // filtering
      if (this.search !== '') {
        let searchlc = this.search.toLowerCase()
        return _.filter(this.items, item => {
          let str = _.join(_.map(this.headers, header => item[header.value]), ' ')
          return str.toLowerCase().indexOf(searchlc) !== -1
        })
      }

      if (this.sortBy) {
        items = _.orderBy(this.items, this.sortBy, [this.sortDirection])
      }

      return items
    }
  },
  methods: {
    getValue (item, path) {
      return _.get(item, path)
    },
    selectedIndex (item) {
      return _.findIndex(this.selectedItems, selectedItem => selectedItem[this.identifier] === item[this.identifier])
    },
    isAllSelected () {
      return this.result.length > 0 && this.result.length === this.selectedItems.length
    },
    onClick (item) {
      this.$emit('click', item)
    },
    onSelect (item) {
      var index = this.selectedIndex(item)
      if (index === -1) {
        this.selectedItems.push(item)
      } else {
        this.selectedItems.splice(index, 1)
      }
      this.$emit('input', this.selectedItems)
    },
    onSelectAll () {
      this.selectedItems = this.isAllSelected() ? [] : [...this.result]
      this.$emit('input', this.selectedItems)
    },
    itemClass (item, index) {
      const isSelected = this.selectedIndex(item) >= 0
      const isOdd = index % 2 !== 0
      return {
        'bg-gray-400': isSelected,
        'bg-gray-200 hover:bg-gray-300': !isSelected && isOdd,
        'hover:bg-gray-300': !isSelected && !isOdd
      }
    },
    sort (fieldName) {
      if (this.sortBy === fieldName) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortBy = fieldName
      }
    }
  },
  mounted () {
    if (this.input) {
      this.selectedItems = [...this.input]
    }
  }
}
</script>